import * as React from "react";
import { ImportAddStepsActions, ImportConfigActions, ImportResultsActions, ImportSagaActions, ImportSidePanelActions } from "./actions";
import { Version } from "./models";
import {
  importAddStepsInitialState,
  importAddStepsReducer,
  importConfigInitialState,
  importConfigReducer,
  importResultsInitialState,
  importResultsReducer,
  importSagaInitialState,
  importSagaReducer,
  importSidePanelInitialState,
  importSidePanelReducer,
} from "./reducers";
import { ImportAddStepsState, ImportConfigState, ImportResultsState, ImportSagaState, ImportSidePanelState } from "./state";
import { JSX } from "react";

interface ProviderNetworkImportProps {
  addSteps: ImportAddStepsState;
  addStepsDispatch: React.Dispatch<ImportAddStepsActions>;
  config: ImportConfigState;
  configDispatch: React.Dispatch<ImportConfigActions>;
  results: ImportResultsState;
  resultsDispatch: React.Dispatch<ImportResultsActions>;
  setVersions: React.Dispatch<React.SetStateAction<Array<{ id: number, createDate: string, activationDate: string }>>>;
  saga: ImportSagaState;
  sagaDispatch: React.Dispatch<ImportSagaActions>;
  sidePanel: ImportSidePanelState;
  sidePanelDispatch: React.Dispatch<ImportSidePanelActions>;
  versions: Version[];
}

export const ProviderNetworkImportContext = React.createContext<Partial<ProviderNetworkImportProps>>({});

export const ProviderNetworkImportProvider = ({ children }: { children: React.ReactNode }): JSX.Element => {
  const [versions, setVersions] = React.useState<Version[]>([]);
  const [addSteps, addStepsDispatch] = React.useReducer(importAddStepsReducer, importAddStepsInitialState);
  const [config, configDispatch] = React.useReducer(importConfigReducer, importConfigInitialState);
  const [results, resultsDispatch] = React.useReducer(importResultsReducer, importResultsInitialState);
  const [sidePanel, sidePanelDispatch] = React.useReducer(importSidePanelReducer, importSidePanelInitialState);
  const [saga, sagaDispatch] = React.useReducer(importSagaReducer, importSagaInitialState);

  return (
    <ProviderNetworkImportContext.Provider
      value={{
        addSteps,
        addStepsDispatch,
        config,
        configDispatch,
        results,
        resultsDispatch,
        saga,
        sagaDispatch,
        setVersions,
        sidePanel,
        sidePanelDispatch,
        versions,
      }}
    >
      {children}
    </ProviderNetworkImportContext.Provider>
  );
};
